import React from "react"

export const USER_ROLE = {
  compliance: 'Compliance',
  hr: 'Recursos Humanos',
  admin: 'Administrador',
  adminReadOnly: 'Apenas Leitura',
}

/** Possíveis status de um item da aplicação. Valores usados pela API. */
export const ITEM_STATUS = {
  processing: 'PROCESSING',
  processed: 'PROCESSED',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT = {
  approved: 'APPROVED',
  reproved: 'REPROVED',
  waitingForReview: 'WAITING_FOR_REVIEW',
  waitingReview: 'WAITING_REVIEW',
}

/** Possíveis status de uma aplicação. Valores usados pela API. */
export const APPLICATION_STATUS = {
  created: 'CREATED',
  bgcProcessing: 'BGC_PROCESSING',
  bgcProcessed: 'BGC_PROCESSED',
  bgcReported: 'BGC_REPORTED',
  rfcProcessing: 'RFC_PROCESSING',
  rfcProcessed: 'RFC_PROCESSED',
  rfcReported: 'RFC_REPORTED',
}

/** Possíveis status de uma aplicação. Valores mostrados ao usuário. */
export const APPLICATION_STATUS_DESCRIPTION = {
  created: 'Aplicação iniciada',
  bgcProcessing: 'Processando BGC',
  bgcProcessed: 'Análise de Crédito Pendente',
  rfcProcessing: 'Processando Análise de Crédito',
  rfcProcessed: 'Concluído',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT_DESCRIPTION = {
  approved: 'Aprovado(a)',
  reproved: 'Reprovado(a)',
  waitingForReview: 'Revisão necessária',
}

export const WAITING_CLARIFICATION_VALUES = {
  ALL: undefined,
  SHOW: true,
  HIDE: false,
}

export const SUSPENDED_ANALYSIS_MESSAGE = (
  <p>
    Uma revisão pendente é SUSPENSA se o candidato:
    <br></br>
    1. é marcado como &quot;Rejected&quot; ou &quot;Hired&quot; na Greenhouse sem que tenha passado por todo o fluxo; ou 
    <br></br>
    2. foi REPROVADO em outra análise, logo nenhuma decisão é necessária sobre esta.
  </p>
)
